/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */

/**
 * Import modules / classes
 */
import Accordion from "./modules/Accordion";

import WCArchiveTagsSlider from "./modules/WCArchiveTagsSlider";
import WCArchiveLoadMore from "./modules/WCArchiveLoadMore";
import WCArchiveSidebar from "./modules/WCArchiveSidebar";
import WCArchiveOrderBy from "./modules/WCArchiveOrderBy";
import WCArchiveDateWidget from "./modules/WCArchiveDateWidget";
import WCArchivePayuInstallments from "./modules/WCArchivePayuInstallments";

/**
 * Instantiate a new object using imported modules/classes
 */
document.addEventListener("DOMContentLoaded", () => {
    const wcArchiveSidebarAccordions = [
        ...document.querySelectorAll(".jsSidebarAccordion"),
    ];

    if (wcArchiveSidebarAccordions.length) {
        wcArchiveSidebarAccordions.forEach((sidebarAccordion) => {
            const mysidebarAccordion = new Accordion(sidebarAccordion, {
                btnClass: "jsSidebarAccordionBtn",
                contentClass: "jsSidebarAccordionContent",
                allowOpeningAll: true,
                accordionOpenOnInit: true,
            });
        });
    }

    const myWCArchiveTagsSlider = new WCArchiveTagsSlider();
    const myWCArchiveLoadMore = new WCArchiveLoadMore();
    const myWCArchiveSidebar = new WCArchiveSidebar();
    const myWCArchiveOrderBy = new WCArchiveOrderBy();
    const myWCArchiveDateWidget = new WCArchiveDateWidget();
    const myWCArchivePayuInstallments = new WCArchivePayuInstallments();
});
